export { default } from './Container';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Container/index.js
// module id = 663
// module chunks = 0